// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"b2373950","254":"b6a58bba","279":"d4764087","308":"dcb8851c","381":"74206aca","578":"ac8fad47"}[chunkId] + ".css";
};